import { apiClient } from "~/services/api-client";
import type { DeliveryWindowPreset } from "~/shared/utils/delivery-window";

export type DeliveryWindow = {
  type: string;
  start: number;
  end: number;
  label: string;
  startMinutes?: number;
  endMinutes?: number;
};

export type AppMetadata = {
  jobLocations: string[];
  deliveryWindows: DeliveryWindow[];
  /** Autocall window presets (standard + REF-0007 location windows); absent on older backends */
  deliveryWindowPresets?: DeliveryWindowPreset[];
};

type MetadataApiResponse = {
  success: boolean;
  data: AppMetadata;
  txId: string;
};

/**
 * Fetch app metadata (jobLocations + deliveryWindows) from the API.
 */
export async function fetchMetadata(): Promise<AppMetadata> {
  try {
    const response = await apiClient.get<MetadataApiResponse>('/dashboard/metadata');

    if (
      response.data.success &&
      response.data.data &&
      Array.isArray(response.data.data.deliveryWindows) &&
      Array.isArray(response.data.data.jobLocations)
    ) {
      return response.data.data;
    }

    throw new Error('Invalid response format from metadata API');
  } catch (error) {
    console.error('Failed to fetch metadata:', error);
    throw error;
  }
}
